"use client"

import * as React from "react"
import { cn } from "../../lib/utils"

export interface NavItem {
  id: string
  label: string
  icon: React.ReactNode
  isActive?: boolean
}

export interface FloatingNavbarProps {
  className?: string
  items: NavItem[]
  onItemClick?: (id: string) => void
  trailingAction?: React.ReactNode
  buttonClassName?: string
}

function FloatingNavbar({ className, items, onItemClick, trailingAction, buttonClassName }: FloatingNavbarProps) {
  return (
    <div
      className={cn(
        "fixed bottom-6 left-1/2 -translate-x-1/2 z-50 flex items-stretch gap-2",
        className
      )}
    >
      <nav className="bg-white border border-[#667085] rounded-lg p-1 sm:p-1.5 shadow-[0px_4px_0px_0px_#000000] flex items-center gap-0.5 sm:gap-1 w-full max-w-[calc(100vw-24px)] sm:max-w-none overflow-x-auto no-scrollbar">
        {items.map((item) => (
          <button
            key={item.id}
            type="button"
            onClick={() => onItemClick?.(item.id)}
            className={cn(
              "flex flex-col items-center justify-center gap-0.5 px-1 py-1.5 rounded flex-1 min-w-[64px] sm:min-w-[70px] max-w-[75px] transition-colors overflow-hidden", buttonClassName,
              item.isActive
                ? "bg-[#f9f9f9]"
                : "bg-white hover:bg-gray-50 cursor-pointer"
            )}
          >
            <div
              className="size-[18px] sm:size-[20px] flex shrink-0 items-center justify-center mb-0.5"
              style={{ color: item.isActive ? "#ED5AA9" : "#667085" }}
            >
              {item.icon}
            </div>
            <span
              className={cn(
                "text-[11px] sm:text-xs leading-tight w-full block text-center tracking-tight",
                item.isActive
                  ? "text-[#ED5AA9] font-semibold"
                  : "text-[#667085] font-medium"
              )}
            >
              {item.label}
            </span>
          </button>
        ))}
      </nav>
      {trailingAction}
    </div>
  )
}

export { FloatingNavbar }
